import { NgModule, Renderer2 } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { NativeStorage } from '@awesome-cordova-plugins/native-storage/ngx';


import { HttpClientModule } from '@angular/common/http';
import { IonicSelectableModule } from 'ionic-selectable';

import { Network } from '@ionic-native/network/ngx';
import { FingerprintAIO } from '@ionic-native/fingerprint-aio/ngx';
//import { Camera } from '@capacitor/camera';

import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { Base64 } from '@ionic-native/base64/ngx';
import { ImagePicker } from '@ionic-native/image-picker/ngx';
import { HTTP } from '@ionic-native/http/ngx';

import { Camera } from '@ionic-native/camera/ngx';

import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';
import { MenuComponent } from './components/menu/menu.component';
import { ComponentsModule } from './components/components.module';
import { ConfiguracionPage } from './pages/configuracion/configuracion.page';
import { CalendarModule } from 'ion2-calendar';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { File } from '@ionic-native/file/ngx';
import { FileChooser } from '@ionic-native/file-chooser/ngx';

import { Media } from '@ionic-native/media/ngx';
import { FilePath } from '@ionic-native/file-path/ngx';
import { Diagnostic } from '@ionic-native/diagnostic/ngx';

import { FileOpener } from '@ionic-native/file-opener/ngx';

import { SQLite } from '@ionic-native/sqlite/ngx';  
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { DocumentViewer } from '@awesome-cordova-plugins/document-viewer/ngx';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxPaginationModule } from 'ngx-pagination';
import { FileTransfer } from '@ionic-native/file-transfer/ngx';
import { Chooser } from '@ionic-native/chooser/ngx';
import { DocumentosPipe } from './pages/documentos.pipe';


//import { SQLite } from '@ionic-native/sqlite';

//importar { SQLite } desde ' @ionic-native/sqlite '      ;
//import { SqlProvider } from 'ionic-query-interface'      ;

//import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';

//import { File } from '@ionic-native/file';
//import { FileOpener } from '@ionic-native/file-opener';
//import { NgChartsModule } from 'ng2-charts';
//import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';


@NgModule({
  declarations: [AppComponent, DocumentosPipe],
  imports: [BrowserModule,NgxPaginationModule, NgxDatatableModule, IonicModule.forRoot(), AppRoutingModule,
    HttpClientModule,    
    IonicSelectableModule,ComponentsModule, CalendarModule  
    
  
  
  ],
  providers: [
    Chooser,
    File,
    Media,
    FilePath,
    FileOpener,
    InAppBrowser,   
    Network,
    Camera,
    FingerprintAIO,
    Base64 ,
    ImagePicker,
    BarcodeScanner,
    HTTP,
    SQLite,AndroidPermissions,
    DocumentViewer,SocialSharing,
    Diagnostic,     
    FileTransfer,
    FileChooser,
    
    //SqlProvider,
   
    MenuComponent,
    BarcodeScanner,
    NativeStorage,{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy }],
  bootstrap: [AppComponent],
})
export class AppModule {}
